/* ============================================================
   LIORA - Motion fuer Produktseiten
   Wird nur auf Produktseiten geladen (layout/theme.liquid).

   Scroll-Reveals fuer alles unterhalb des Kaufbereichs:
   Passt gut zusammen, Gruendernotiz, Trust-Streifen,
   Kategorien, Zuletzt angesehen und Ueberschriften.

   Die Produktbeschreibung und die Atelier-Story (eigene Reveals),
   der Bildbereich und die Bewertungen bleiben unangetastet. Im Theme-Editor und bei
   'Bewegung reduzieren' passiert nichts. Inhalte bleiben ohne
   JavaScript immer sichtbar.
   ============================================================ */
(() => {
  'use strict';

  const root = document.documentElement;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (root.classList.contains('shopify-design-mode')) return;
  if (!('IntersectionObserver' in window)) return;

  const main = document.getElementById('MainContent');
  if (!main) return;

  const CONFIG = {
    stagger: 80,
    maxStaggerSteps: 4,
  };

  root.classList.add('lm-js');

  const SKIP = '.liora-product-description, media-gallery, [data-la-reveal], liora-story';
  const candidates = [];

  const add = (selector, type, resolve) => {
    main.querySelectorAll(selector).forEach((node) => {
      const el = resolve ? resolve(node) : node;
      if (!el || el.closest(SKIP)) return;
      candidates.push([el, type]);
    });
  };

  add('.liora-inline-pairings', 'rise');
  add('.liora-founder-note', 'rise');
  add('.liora-product-trust__item', 'rise');
  add('.liora-pdp-category-nav__card', 'tile');
  add('[class*=liora-recently-viewed__shell-]', 'rise');
  add('.shopify-section h2', 'heading', (node) => {
    if (node.classList.contains('visually-hidden')) return null;
    return node.closest('.product-details') ? null : node;
  });

  const fold = window.innerHeight * 0.92;
  const elements = [];

  candidates.forEach(([el, type]) => {
    if (el.hasAttribute('data-lm')) return;
    if (el.parentElement && el.parentElement.closest('[data-lm]')) return;
    if (el.getBoundingClientRect().top <= fold) return;
    el.setAttribute('data-lm', type);
    elements.push(el);
  });

  const pending = new Set(elements);

  const finish = (el) => {
    el.removeAttribute('data-lm');
    el.classList.remove('is-in');
    el.style.removeProperty('--lm-delay');
  };

  const revealObserver = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left);

      visible.forEach((entry, index) => {
        reveal(entry.target, Math.min(index, CONFIG.maxStaggerSteps) * CONFIG.stagger);
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
  );

  const reveal = (el, delay) => {
    if (!pending.has(el)) return;
    pending.delete(el);
    revealObserver.unobserve(el);
    el.style.setProperty('--lm-delay', delay + 'ms');
    el.classList.add('is-in');
    window.setTimeout(() => finish(el), 2400 + delay);
  };

  elements.forEach((el) => revealObserver.observe(el));

  /* Sicherheitsnetz: Was im Bild liegt, aber vom Observer nicht
     gemeldet wurde, wird trotzdem eingeblendet. */
  const rescueTimer = window.setInterval(() => {
    if (!pending.size) {
      window.clearInterval(rescueTimer);
      return;
    }
    const vh = window.innerHeight;
    pending.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.height > 0 && rect.top < vh * 0.9 && rect.bottom > 0) reveal(el, 0);
    });
  }, 1200);
})();
